"use client";

import React, { Children, useEffect, useRef } from "react";
import HTMLEditor from "./HTMLEditor";
import ContentSection from "./ContentSection";

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export default function ContentSwitchEditor({
  children,
  sectionId,
  className,
  pageId,
  isEditing,
  section,
}) {
  // Safely access section properties with defaults
  const normalizedContent = section?.contentData
    ? section.contentData.replace(/\\n/g, "\n")
    : "";
  const sectionStyle = {
    backgroundColor: section?.bgColor || "transparent",
    backgroundImage: section?.bgImg ? `url(${section.bgImg})` : "none",
    backgroundSize: "cover",
    backgroundPosition: "center",
    opacity: section?.bgOpacity || 1,
  };

  const editorRef = useRef(null);
  const prevIsEditing = usePrevious(isEditing);

  useEffect(() => {
    if (prevIsEditing && !isEditing) {
      if (editorRef.current) {
        editorRef.current.save();
      }
    }
  }, [isEditing, prevIsEditing]);

  const handleSaveClick = () => {
    if (editorRef.current) editorRef.current.save();
  };

  return (
    <>
      {isEditing ? (
        <HTMLEditor
          ref={editorRef}
          pageId={pageId}
          sectionId={`${sectionId}`}
          contentData={normalizedContent}
          extraFields={{
            bgColor: section?.bgColor || "",
            bgImg: section?.bgImg || "",
            bgOpacity: section?.bgOpacity || 1,
            classes: section?.classes || "",
          }}
          classes={`ContentSwitchEditor  ${section?.classes || ""} ${className || ""}`}
          style={sectionStyle}
        >
          {children}
        </HTMLEditor>
      ) : // Show placeholder if no content and not editing
      normalizedContent || section || children ? (
        <ContentSection
          pageId={pageId}
          sectionId={`${sectionId}`}
          bgColor={section?.bgColor || ""}
          bgImg={section?.bgImg || ""}
          bgOpacity={section?.bgOpacity || 1}
          contentData={normalizedContent}
          classes={`ContentSwitchEditor  ${section?.classes || ""} ${className || ""}`}
        >
          {children}
        </ContentSection>
      ) : (
        <></>
      )}
    </>
  );
}
